<template>
    <VoucherTable :userId="userId" />
</template>

<script>
import VoucherTable from './VoucherTable.vue'

export default {
    props: {
        userId: {
            type: [Number, String, null],
            required: false,
            default: null,
        },
    },
    components: {
        VoucherTable,
    },
}
</script>
